import React from 'react'
import { AppContext } from '../../context'
import Slide from '../ui/Slide'

const TrialPopover: React.FC = () => {
  const subscriptionUrl = `${process.env.REACT_APP_SUBSCRIPTIONS_URL}booksSubscriptions/`

  return (
    <AppContext.Consumer>
      {({ activePopover, userSubscriptionStatus }) => (
        <Slide
          id="info-overlay"
          className="card border-light overlay overlay-left"
          isVisible={activePopover === 'trial'}
        >
          {/* @*
          <div id="close">
            <a className="close-button material-icons">clear</a>
          </div>
          *@ */}

          {
            !userSubscriptionStatus?.hasSubscription ? (
              <div id="free-trial-container">
                <h4>You're in a free trial</h4>
                <span>
                  As part of your free trial you have limited interaction on the
                  map. You have{' '}
                  <b>
                    <span id="trial-data-views-counter">
                      {userSubscriptionStatus?.trialExpiresIn ?? 0}
                    </span>
                    /3
                  </b>{' '}
                  days remaining.
                </span>
                <br />
                <a
                  id="trial-info-overlay-subscribe-button"
                  className="btn btn-primary"
                  href={subscriptionUrl}
                >
                  Join
                </a>
              </div>
            ) : userSubscriptionStatus?.hasSubscription ? (
              <div id="subscribed-container">
                <h4>You have an Explorer membership</h4>
                <span>
                  Explorers can access all Imray cruising guide data and Imray
                  raster charts available within Explore with Imray.
                </span>
              </div>
            ) : null // NoSubscription
          }
        </Slide>
      )}
    </AppContext.Consumer>
  )
}

export default TrialPopover
